<ng-container *ngIf="goal$|async; let goal; else loader">

  <div class="lp-cover lp-cover-heading c-img-container">
    <div [innerHtml]="goal.headerImage"></div>

    <div class="l-container c-img-content">
      <div class="lp-cover-title">
        <span class="subtitle">{{goal.subtitle}}</span>
        <h1>
          <span class="title">{{goal.title}}</span>
        </h1>
        <div class="lp-plan-start-btn--desktop">
          <a [routerLink]="goal.baseRoute.calculatorRoute" class="btn btn-primary s-panel-btn">
            Let's get started
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="l-container s-content lp-plan-content">
    <div class="lp-plan-start-btn--mobile">
      <a [routerLink]="goal.baseRoute.calculatorRoute" class="btn btn-primary s-panel-btn">
        Let's get started
      </a>
    </div>
    <ng-container *ngFor="let goalPlan of goal.plans">
      <h2 id="skip-to-main-focus" class="lp-plan-heading">{{goalPlan.title}}</h2>
      
      <div class="l-row">
        <div class="l-col-std-sm">
          <article [innerHTML]="goalPlan.description" class="lp-plan-description">
            @Html.Raw(goalPlan.description)
          </article>

          <ng-container *ngIf="goalPlan.showWhatYouGet">
            <h3>{{goalPlan.whatYouGetTitle}}</h3>
            <article [innerHTML]="goalPlan.whatYouGetDescription"></article>
          </ng-container>

          <ng-container *ngIf="goalPlan.showWhatWeAsk">
            <h3>{{goalPlan.whatWeAskTitle}}</h3>
            <article [innerHTML]="goalPlan.whatWeAskDescription"></article>
          </ng-container>

        </div>
        <div class="l-col-aside-md">
          <ng-container *ngIf="goalPlan.showSample">
            <hr class="m-margin-top-xs m-margin-bottom-xxs"/>
            <div class="c-panel-out lp-plan-sample">
              <h4>{{goalPlan.sampleTitle}}</h4>
              <p [innerHTML]="goalPlan.sampleDescription"></p>
              <div><img [attr.alt]="goalPlan.sampleTitle" [src]="goalPlan.sampleImage"></div>
            </div>
          </ng-container>

        </div>
      </div>

      <div *ngIf="goalPlan.quickFact" [innerHTML]="goalPlan.quickFact" class="l-row lp-plan-quick-fact"></div>
    </ng-container>
  </div>

</ng-container>

<ng-template #loader>
  <div [loading]="true" ey-loader="graphic" style="height: 300px"></div>
</ng-template>
